import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NeedHelpComponent } from './need-help.component';

@NgModule({
    declarations: [NeedHelpComponent],
    imports: [CommonModule],
    exports: [NeedHelpComponent],
})
export class NeedHelpModule {}
